// extracted by mini-css-extract-plugin
export default {"greenTick":"icons_greenTick__+LnvN","redCross":"icons_redCross__dhFcp"};